import React, { Component, PropTypes } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import { push as routerPush } from 'react-router-redux';
import moment from 'moment';
import { toLaxTitleCase } from 'titlecase';

import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import FontIcon from 'material-ui/FontIcon';
import CircularProgress from 'material-ui/CircularProgress';
import RefreshIndicator from 'material-ui/RefreshIndicator';

import { getStatusColor, getShownState } from '../contracting/contractingUtils';

const styles = {
  content: {
    margin: '1em',
    textAlign: 'center',
    padding: '1em',
    backgroundColor: '#f4f6fa !important',
    borderRadius: '10px !important',
    '&.loading': {
      opacity: '0.7',
    },
  },
  header: {
    fontSize: '1em',
    marginBottom: '0.4em',
    textAlign: 'left',
  },
  yearSplit: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  yearSplitDivider: {
    flex: '1 0 auto',
  },
  yearSplitLabel: {
    flex: '0 1 auto',
    paddingLeft: '1em',
    fontSize: '0.7em',
    color: '#9e9e9e',
  },
  contractItemRow: {
    cursor: 'pointer',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&>.hoverText': {
      fontSize: '0.8em',
      visibility: 'hidden',
    },
    '&:hover>.hoverText': {
      visibility: 'visible !important',
    },
  },
  contractItem: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '2.2em',
    '&.splitBorder': {
      borderTop: '1px solid #e0e0e0',
      marginTop: '0.5em',
      paddingTop: '0.8em',
    },
  },
  contractItemIcon: {
    flex: '0 1 auto',
    display: 'flex',
    flexDirection: 'column',
  },
  contractItemIconFontIcon: {
    color: '#9e9e9e !important',
  },
  contractItemIconTextCaption: {
    fontSize: '0.7em',
  },
  contractItemDesc: {
    fontSize: '0.8em',
    marginLeft: '1em',
    color: '#616161',
    display: 'flex',
    flexDirection: 'column',
  },
  contractItemDescContractName: {
    textAlign: 'left',
  },
  contractItemDescFontIcon: {
    color: '#9e9e9e !important',
    fontSize: '1.6em !important',
    marginRight: '0.2em',
  },
  templateName: {
    display: 'flex',
    flexDirection: 'row',
    flex: '1 1 auto',
    alignItems: 'center',
  },
  templateNameText: {
    overflow: 'hidden',
    height: '2em',
    textAlign: 'left',
  },
  loading: {
    margin: 'auto',
    textAlign: 'center',
    paddingBottom: '1em',
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
  },
};

class ContractingFiles extends Component {
  constructor(props) {
    super(props);
  }
  jumpToContract = (contractId) => {
    const url = `/contracting/contract/${contractId}/activities`;
    this.props.routerPush(url);
  }
  render() {
    const { classes, files, companyId, filesLoading, filesLoaded, resourceType } = this.props;
    const listItems = files.reduce((data, current) => {
      const year = moment(current.startDate).format('YYYY');
      data[year] = [...(data[year] || []), {
        ...current,
        shownState: getShownState({ ...current, companyType: toLaxTitleCase(resourceType) }),
        startYear: moment(current.startDate).format('YYYY'),
        endYear: moment(current.endDate).format('YYYY'),
      }];
      return data;
    }, {});
    if (filesLoaded) {
      return (
        <Paper className={`${classes.content}${filesLoading ? ' loading' : ''}`}>
          <div className={classes.header}>Contracting Files</div>
          {Object.keys(listItems).sort((a, b) => (~~b - ~~a)).map(year => (<div key={year}>
            <div className={classes.yearSplit}>
              <Divider className={classes.yearSplitDivider} />
              <div className={classes.yearSplitLabel}>{year}</div>
            </div>
            {listItems[year].map(({
              companyName,
              endDate,
              endYear,
              _id: id,
              locationName,
              startDate,
              startYear,
              shownState: state,
              templateName,
              supplierId,
            }, ix) => (<div key={id} className={classes.contractItemRow} onTouchTap={() => { this.jumpToContract(id); }}>
              <div
                className={`${classes.contractItem} ${(ix > 0) ? ' splitBorder' : ''}`}
              >
                <div className={classes.contractItemIcon}>
                  <FontIcon className={`tc-icon-description ${classes.contractItemIconFontIcon}`}/>
                  <div className={`${classes.contractItemIconTextCaption}`} style={ { color: getStatusColor(state) }}>{state.replace(/^\w/, c => c.toUpperCase())}</div>
                </div>
                <div className={classes.contractItemDesc}>
                  <div className={classes.contractItemDescContractName}>{(companyName !== locationName) ? locationName : null} {(startYear !== endYear) ? `${startYear}-${endYear}` : startYear}</div>
                  {(companyId === supplierId) ? <div className={classes.templateName}>
                    <FontIcon className={`tc-icon-receipt ${classes.contractItemDescFontIcon}`}/>
                    <div className={classes.templateNameText}>{templateName}</div>
                  </div> : undefined}
                </div>
              </div>
              <div className="hoverText">View</div>
            </div>))}
          </div>))}
        </Paper>
      );
    }
    if (filesLoading) {
      return (
        <Paper className={classes.content}>
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        </Paper>
      );
    }
    return (
      <Paper className={classes.content}>
        <div className={classes.loading}>
          <RefreshIndicator
            percentage={80}
            size={60}
            left={0}
            top={0}
            color="red"
            status="ready"
            style={styles.refresh}
          />
        </div>
      </Paper>
    );
  }
}

ContractingFiles.propTypes = {
  classes: PropTypes.object,
  companyId: PropTypes.string,
  files: PropTypes.array,
  routerPush: PropTypes.func,
  filesLoading: PropTypes.bool,
  filesLoaded: PropTypes.bool,
  resourceType: PropTypes.string,
};

const select = ({ partnerDetails: { files, filesLoading, filesLoaded, resourceType }, user }) => ({
  companyId: user.getIn(['company', 'companyId']),
  files,
  filesLoaded,
  filesLoading,
  resourceType,
});

export default connect(select, { routerPush })(injectSheet(styles)(ContractingFiles));



// WEBPACK FOOTER //
// ./src/app/components/partner-details/contracting-files.jsx